import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  batchId: string;
  templateId: string;
}

export const useGenerateProformaB2BInvoice = () => {
  return useMutation({
    mutationFn: async ({ batchId, templateId }: HookProps) => {
      await request({
        path: 'batches/generate-proforma-b2b-invoice',
        method: 'POST',
        authenticate: true,
        dataObject: { batchId, templateId },
      });
    },
    onSuccess: () => {
      toast.success('Proforma B2B Invoice generation started!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error generating Proforma B2B Invoice!');
    },
  });
};
